import type {SVGProps, FC} from 'react';

export const MarkAsUnreadIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg viewBox='0 0 24 24' fill='currentColor' xmlns='http://www.w3.org/2000/svg' {...props}>
            <path d='M3 5V7H21V5H3ZM21 10V14H19L17 12L19 10H21ZM3 11V13H15V11H3ZM3 17V19H21V17H3Z' />
        </svg>
    );
};

